import cn from 'classnames';
import { FC, useMemo, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { CmsRelationItem } from 'src/types/cms/cmsFieldTypes';
import { CmsSlider } from 'src/types/cms/cmsWidgetTypes';
import { Settings } from 'src/types/common-types/slider';
import { RootState } from 'src/types/store-types';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Arrows } from '../components/Arrows';
import '../styles.scss';
import CarouselSlideItem from './SlidetItem';

type Props = {
  settings: Settings;
  sliderData?: CmsRelationItem<CmsSlider> | null;
  pageLoaded?: boolean;
};

const pagination = {
  clickable: true,
  renderBullet: function (index: number, className: string) {
    return '<span class="' + className + '" key="' + index + '"></span>';
  },
};

const BannerSlider: FC<Props> = ({ settings, sliderData, pageLoaded }) => {
  const { cols, rows, type, arrowPlacement, arrowsType } = settings;

  const { generalConfigs } = useSelector((state: RootState) => state.configs);

  const [my_swiper, set_my_swiper] = useState<any>({});

  const bannersArray = useMemo(() => {
    return sliderData?.relation?.slides?.map((item: any) => {
      return item;
    });
  }, [sliderData]);

  if (!bannersArray?.length) {
    if (pageLoaded) {
      return null;
    }

    return (
      <div className={cn('banner_container', type)} aria-hidden="true">
        <div className={cols === 12 ? 'bannerItem' : 'small_bannerItem'} style={{ width: `${100 / (12 / cols)}vw` }} />
        <div className="banner_placeholder_pagination" />
      </div>
    );
  }

  return (
    <div className={cn('banner_container', type)}>
      <Swiper
        loop
        className="carousel_container"
        slidesPerView={settings.slidersPerView || 1}
        spaceBetween={settings.spaceBetween || 0}
        autoplay={{
          delay: 5000,
        }}
        speed={1500}
        slidesPerGroup={settings.slidersPerGroup || 1}
        pagination={pagination}
        navigation={{ nextEl: '.arrow-right', prevEl: '.arrow-left' }}
        modules={[Pagination, Navigation, Autoplay]}
        onInit={(ev: any) => {
          set_my_swiper(ev);
        }}
      >
        {bannersArray.map((carouselItemData: any[], i: number) => {
          return (
            <SwiperSlide key={i}>
              <div className="carousel_item_container">
                <CarouselSlideItem cols={cols} rows={rows} carouselItemData={carouselItemData} isFirst={i === 0} />
              </div>
            </SwiperSlide>
          );
        })}
        {isDesktop && bannersArray.length > 1 && (
          <Arrows
            rows={rows}
            placement={arrowPlacement}
            type={arrowsType}
            template={generalConfigs.template}
            size={cols === 12 ? 'lg' : 'md'}
            nextClick={() => my_swiper?.slideNext()}
            prevClick={() => my_swiper?.slidePrev()}
          />
        )}
      </Swiper>
    </div>
  );
};
export default BannerSlider;
